import React from 'react';
import { useMediaQuery } from '@/lib/hooks';

export function ViewportInfo() {
  // Only show in development mode
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  const isSm = useMediaQuery('(min-width: 640px)');
  const isMd = useMediaQuery('(min-width: 768px)');
  const isLg = useMediaQuery('(min-width: 1024px)');
  const isXl = useMediaQuery('(min-width: 1280px)');
  const is2xl = useMediaQuery('(min-width: 1536px)');

  const currentBreakpoint = () => {
    if (is2xl) return '2xl';
    if (isXl) return 'xl';
    if (isLg) return 'lg';
    if (isMd) return 'md';
    if (isSm) return 'sm';
    return 'xs';
  };

  return (
    <div className="fixed bottom-2 right-2 z-50 rounded-full bg-black/75 text-white px-3 py-1.5 text-xs font-mono">
      {currentBreakpoint()}
    </div>
  );
} 